import classNames from "classnames";
import type { HTMLAttributes } from "react";

export type PageIntroProps = HTMLAttributes<HTMLDivElement>;

export const PageIntro = ({ children, ...props }: PageIntroProps) => {
  const classes = classNames("page-intro", props.className);
  return (
    <div {...props} className={classes}>
      {children}
    </div>
  );
};

export default PageIntro;
